/**
 * Route for `commission-preview`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CommissionPreviewPage } from "../features/commission-preview/CommissionPreviewPage";

export const commissionPreviewRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/commission-preview",
	component: CommissionPreviewPage,
});

export default commissionPreviewRoute;
